import React, { useState, useEffect } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Switch, Route, Link, useRouteMatch, useLocation } from 'react-router-dom';
import LoginCredentials from '../components/settings/login-credentials';
import SecurityEventsLog from '../components/settings/security-events-log';
import Messages from '../components/settings/messages';
import Notifications from '../components/settings/notifications';
import ColorTheme from '../components/settings/color-theme';
import PaymentMethods from '../components/settings/payment-methods';
import Invoices from '../components/settings/invoices';
import { gray, blue, theme } from '../theme';
import { DRAWER_BREAK_POINT } from '../utils';

const drawerWidth = window.innerWidth <= DRAWER_BREAK_POINT ? window.innerWidth : 320;

const Settings = () => {
  const [isDrawerOpen, toggleDrawer] = useState(true);
  const { path } = useRouteMatch();
  const location = useLocation();
  let activeText = 'Login Credentials';
  let activeTab = 'loginCredentials';

  const {
    drawerBackground,
    drawerBorderColor,
    drawerTextColor,
    drawerFontSize,
    drawerFontWeight,
    // Drawer Tabs
    tabBackground,
    tabActiveBackground,
    tabHoverBackground,
    tabIndicatorBackground,
    tabIndicatorHoverBackground,
    tabIndicatorActiveBackground,
    tabTextColor,
    tabHoverTextColor,
    tabActiveTextColor,
    headerBackground,
    headerTextColor,
    groupHeaderTextColor,
    groupHeaderTextOpacity,
    groupHeaderFontSize,
    groupHeaderFontWeight,
    groupTabIndent
    // tabFontSize,
    // tabFontWeight,
    // groupSeparators,
    // headerFontSize,
    // headerFontWeight,
  } = theme.splitPanelDrawer;

  const styles = StyleSheet.create({
    splitPanel: {
      display: 'flex',
      flexFlow: 'row nowrap',
      // position: 'relative',
      background: gray[800],
      height: 'calc(100vh - 57px)',
      width: '100%',
      overflow: 'hidden',
      fontFamily: 'Lato'
    },
    drawer: {
      position: 'relative',
      height: '100%',
      transition: '0.3s',
      padding: '0',
      overflowY: 'auto',
      zIndex: '1600',
      borderRight: `1px solid ${drawerBorderColor}`,
      background: drawerBackground,
      color: drawerTextColor,
      fontSize: drawerFontSize,
      fontWeight: drawerFontWeight
    },
    openDrawer: {
      left: '0',
      minWidth: `${drawerWidth}px`,
      width: `${drawerWidth}px`
    },
    hideDrawer: {
      transition: '0.3s',
      width: '0px',
      minWidth: '0px',
      left: `calc(-1 * ${drawerWidth}px)`
    },
    drawerHeader: {
      height: '40px',
      fontSize: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',
      marginLeft: '8px',
      // cursor: 'pointer',
      background: headerBackground,
      color: headerTextColor,
      borderBottom: `0.5px solid ${drawerBorderColor}`
    },
    drawerHeaderIconContainer: {
      height: '32px',
      width: '32px',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '4px',
      cursor: 'pointer'
    },
    drawerHeaderIcon: {
      fontSize: '24px',
      cursor: 'pointer'
    },
    drawerHeaderTextContainer: {
      textAlign: 'left',
      lineHeight: '14px',
      cursor: 'pointer'
    },
    drawerHeaderText: {
      textAlign: 'center',
      fontSize: '18px',
      cursor: 'pointer',
      paddingLeft: '4px'
    },
    drawerHeaderTextSub: {
      fontSize: '14px',
      cursor: 'pointer'
    },
    drawerTabsContainer: {
      height: 'calc(100% - 64px)',
      overflowY: 'auto',
      paddingTop: '8px'
    },
    drawerAccordian: {
      position: 'relative',
      display: 'block',
      transition: '0.5s ease',
      maxHeight: '2000px'
    },
    menuItem: {
      position: 'relative',
      left: '-3px',
      color: gray[300]
    },
    detail: {
      // position: 'relative',
      transition: '0s',
      height: '100%',
      left: '0'
    },
    detailHeader: {
      height: '40px',
      background: '#001824',
      display: 'flex',
      alignItems: 'center',
      // justifyContent: 'space-between',
      borderBottom: '0.5px solid #082840',
      padding: '0 8px'
    },
    profileBanner: {
      borderBottom: '1px solid transparent'
    },
    profileBannerImg: {
      width: '100%',
      height: 'auto',
      maxHeight: '220px'
    },
    bigUserCardContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: '1px solid transparent'
    },
    tabs: {
      // borderBottom: '1px solid red'
    },
    popupMenuContainer: {
      background: '#083050',
      width: '150px',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)'
    },
    popupMenuItem: {
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      color: '#5080B0'
    },
    menuItemIconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '40px',
      width: '40px'
    },
    menuItemIcon: {
      fontSize: '20px'
    },
    accordianRightBorder: {
      position: 'absolute',
      width: '1px',
      height: 'calc(100% - 38px)',
      background: '#305C82',
      left: '13px',
      top: '39px'
    },
    linkStyles: {
      display: 'flex',
      alignItems: 'center',
      color: gray[300]
    },
    selectedLink: {
      color: blue[500]
    },
    drawerFile: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '4px',
      color: groupHeaderTextColor,
      opacity: groupHeaderTextOpacity,
      fontSize: groupHeaderFontSize,
      fontWeight: groupHeaderFontWeight,
      height: '40px'
    },
    drawerFileIcon: {
      fontSize: '32px',
      marginRight: '8px'
    },
    activeDrawerMenuItem: {
      borderLeft: `1px solid ${blue[500]}`,
      color: blue[500],
      background: gray[700]
    },
    // New code
    drawerMenuItem: {
      position: 'relative',
      background: tabBackground,
      color: tabTextColor,
      fill: tabTextColor,
      borderLeft: `1px solid ${tabIndicatorBackground}`,
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',
      paddingLeft: groupTabIndent,
      ':hover:not(.activeitem)': {
        background: tabHoverBackground,
        color: tabHoverTextColor,
        fill: tabHoverTextColor,
        borderLeft: `1px solid ${tabIndicatorHoverBackground}`
      }
    },
    drawerMenuItemIcon: {
      height: '24px',
      width: '30px',
      minWidth: '24px',
      marginRight: '8px',
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '24px'
    },
    drawerMenuItemActive: {
      borderLeft: `1px solid ${tabIndicatorActiveBackground}`,
      color: tabActiveTextColor,
      background: tabActiveBackground
    },
    drawerMenuItemText: {
      width: '100%',
      fontSize: '1rem',
      lineHeight: '14px'
    }
  });

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    handleWindowResize();
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  const handleWindowResize = () => {
    const isMobile = window.innerWidth <= 768;
    console.log('isMobile', isMobile);
    toggleDrawer(!isMobile);
  };

  if (location.pathname.endsWith('/loginCredentials')) {
    activeText = 'Login Credentials';
    activeTab = 'loginCredentials';
  } else if (location.pathname.endsWith('/securityEventsLog')) {
    activeText = 'Security Events Log';
    activeTab = 'securityEventsLog';
  } else if (location.pathname.endsWith('/messages')) {
    activeText = 'Messages';
    activeTab = 'messages';
  } else if (location.pathname.endsWith('/notifications')) {
    activeText = 'Notifications & Alerts';
    activeTab = 'notifications';
  } else if (location.pathname.endsWith('/colorTheme')) {
    activeText = 'Color Theme';
    activeTab = 'colorTheme';
  } else if (location.pathname.endsWith('/paymentMethods')) {
    activeText = 'Payment Methods';
    activeTab = 'paymentMethods';
  } else if (location.pathname.endsWith('/invoices')) {
    activeText = 'Invoices';
    activeTab = 'invoices';
  }

  return (
    <div>
      <div className={css(styles.splitPanel)}>
        {/* Panel Drawer */}
        <div
          className={css(styles.drawer, isDrawerOpen ? styles.openDrawer : styles.hideDrawer)}
        >
          {/* Drawer header */}
          <div className={css(styles.drawerHeader)}>
            {/* Header icon */}
            <div className={css(styles.drawerHeaderIconContainer)}>
              <i className={`fa fa-gear ${css(styles.drawerHeaderIcon)}`} />
            </div>
            {/* Header text */}
            <div className={css(styles.drawerHeaderTextContainer)}>
              <div className={css(styles.drawerHeaderText)}>
                Settings
              </div>
            </div>
          </div>
          {/* Drawer tabs */}
          <div className={css(styles.drawerTabsContainer)}>
            {/* Security */}
            <div className={css(styles.drawerAccordian)}>
              {/* Accordian right border */}
              {/* <div className={css(styles.accordianRightBorder)} /> */}
              <div className={css(styles.drawerFile)}>
                <div>
                  Security
                </div>
              </div>
              {/* Login Credentials */}
              <Link to={`${path}/loginCredentials`}>
                <div
                  className={`noselect ${activeTab === 'loginCredentials' ? 'activeitem' : ''} ${css(styles.drawerMenuItem, activeTab === 'loginCredentials' && styles.drawerMenuItemActive)}`}
                >
                  <div className={css(styles.drawerMenuItemText)}>
                    Login Credentials
                  </div>
                </div>
              </Link>
            </div>
            {/* App Settings */}
            <div className={css(styles.drawerAccordian)}>
              {/* Accordian right border */}
              <div className={css(styles.accordianRightBorder)} />
              <div className={css(styles.drawerFile)}>
                <div>
                  App Settings
                </div>
              </div>
              {/* Messages */}
              <Link to={`${path}/messages`}>
                <div
                  className={`noselect ${activeTab === 'messages' ? 'activeitem' : ''} ${css(styles.drawerMenuItem, activeTab === 'messages' && styles.drawerMenuItemActive)}`}
                >
                  <div className={css(styles.drawerMenuItemText)}>
                    Messages
                  </div>
                </div>
              </Link>
              {/* Notifications & Alers */}
              <Link to={`${path}/notifications`}>
                <div
                  className={`noselect ${activeTab === 'notifications' ? 'activeitem' : ''} ${css(styles.drawerMenuItem, activeTab === 'notifications' && styles.drawerMenuItemActive)}`}
                >
                  <div className={css(styles.drawerMenuItemText)}>
                    Notifications & Alers
                  </div>
                </div>
              </Link>
              {/* Color Theme */}
              <Link to={`${path}/colorTheme`}>
                <div
                  className={`noselect ${activeTab === 'colorTheme' ? 'activeitem' : ''} ${css(styles.drawerMenuItem, activeTab === 'colorTheme' && styles.drawerMenuItemActive)}`}
                >
                  <div className={css(styles.drawerMenuItemText)}>
                    Color Theme
                  </div>
                </div>
              </Link>
            </div>
            {/* Payment Methods & Invoices */}
            <div className={css(styles.drawerAccordian)}>
              {/* Accordian right border */}
              <div className={css(styles.accordianRightBorder)} />
              <div className={css(styles.drawerFile)}>
                <div>
                  Payment Methods & Invoices
                </div>
              </div>
              {/* Payment Methods */}
              <Link to={`${path}/paymentMethods`}>
                <div
                  className={`noselect ${activeTab === 'paymentMethods' ? 'activeitem' : ''} ${css(styles.drawerMenuItem, activeTab === 'paymentMethods' && styles.drawerMenuItemActive)}`}
                >
                  <div className={css(styles.drawerMenuItemText)}>
                    Payment Methods
                  </div>
                </div>
              </Link>
              {/* Invoices */}
              <Link to={`${path}/invoices`}>
                <div
                  className={`noselect ${activeTab === 'invoices' ? 'activeitem' : ''} ${css(styles.drawerMenuItem, activeTab === 'invoices' && styles.drawerMenuItemActive)}`}
                >
                  <div className={css(styles.drawerMenuItemText)}>
                    Invoices
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
        {/* Panel details */}
        <div
          className={css(styles.detail)}
          style={{
            width: isDrawerOpen ? `calc(100vw - ${drawerWidth}px)` : '100vw'
          }}
        >
          <div className={css(styles.detailHeader)}>
            <div
              onClick={() => toggleDrawer(!isDrawerOpen)}
            >
              <i
                className={`mr-2 fa ${isDrawerOpen ? 'fa-chevron-circle-left' : 'fa-chevron-circle-right'}`}
                style={{ fontSize: '24px' }}
              />
            </div>
            <div>{activeText}</div>
          </div>
          {/* Active component */}
          <Switch>
            <Route path={`${path}/loginCredentials`}>
              <LoginCredentials />
            </Route>
            <Route path={`${path}/securityEventsLog`}>
              <SecurityEventsLog />
            </Route>
            <Route path={`${path}/messages`}>
              <Messages />
            </Route>
            <Route path={`${path}/notifications`}>
              <Notifications />
            </Route>
            <Route path={`${path}/colorTheme`}>
              <ColorTheme />
            </Route>
            <Route path={`${path}/paymentMethods`}>
              <PaymentMethods />
            </Route>
            <Route path={`${path}/invoices`}>
              <Invoices />
            </Route>
        </Switch>
        </div>
      </div>
    </div>
  );
};

export default Settings;
